import type { JSX } from "react";
import { Button, InputGroup } from "./ui";
import type { ChildInput } from "../types";

interface ChildrenSectionProps {
  childrenData: ChildInput[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, age: number) => void;
}

export function ChildrenSection({ childrenData, onAdd, onRemove, onChange }: ChildrenSectionProps): JSX.Element {
  return (
    <section className="border-t pt-6">
      <h2 className="font-semibold mb-2">Children (under 18)</h2>

      {childrenData.length === 0 ? (
        <Button
          type="button"
          onClick={onAdd}
          variant="outline"
          fullWidth
        >
          Add Child
        </Button>
      ) : (
        <>
          {childrenData.map((child, idx) => (
            <div key={idx} className="mb-3">
              <InputGroup
                label={`Child ${idx + 1} Age:`}
                inputProps={{
                  id: `child-age-${idx}`,
                  type: "number",
                  min: 0,
                  max: 18,
                  value: child.age,
                  onChange: (e) => onChange(idx, Number(e.target.value)),
                }}
                selectAllOnFocus
                action={
                  <button
                    type="button"
                    onClick={() => onRemove(idx)}
                    className="px-4 py-2 bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors border-l border-red-700"
                  >
                    Remove
                  </button>
                }
              />
            </div>
          ))}
          <Button
            type="button"
            onClick={onAdd}
            variant="outline"
            fullWidth
            className="mt-2"
          >
            Add Child
          </Button>
        </>
      )}
    </section>
  );
}